import { formatPhoneValue, parsePhoneValue, PhoneInput } from '@trellis/roots/forms'
import { AU_ONLY_COUNTRIES } from '@trellis/shared'
import { useEffect, useState } from 'react'

interface PhoneFormFieldProps {
  value: string | undefined
  onChange: (value: string) => void
  onBlur?: () => void
}

/**
 * Locked to Australia for the alpha build — passes AU_ONLY_COUNTRIES instead of the
 * default full country list. Widening back to multi-country is a one-line change: pass
 * COUNTRIES here instead.
 */
export function PhoneFormField({ value, onChange, onBlur }: PhoneFormFieldProps) {
  const { country: parsedCountry, number } = parsePhoneValue(value, AU_ONLY_COUNTRIES)
  const [countryOverride, setCountryOverride] = useState<string | null>(null)
  const country = countryOverride ?? parsedCountry

  useEffect(() => {
    setCountryOverride(null)
  }, [value])

  return (
    <PhoneInput
      country={country}
      value={number}
      countries={AU_ONLY_COUNTRIES}
      onCountryChange={(newCountry) => {
        setCountryOverride(newCountry)
        if (number.trim()) {
          onChange(formatPhoneValue(newCountry, number, AU_ONLY_COUNTRIES))
        }
      }}
      onChange={(newNumber) => {
        setCountryOverride(null)
        onChange(formatPhoneValue(country, newNumber, AU_ONLY_COUNTRIES))
      }}
      onBlur={onBlur}
    />
  )
}
